export enum IdiomaEnum { ESPANOL, PORTUGUES, INGLES, FRANCES }

const nombresIdioma = new Map<IdiomaEnum, string>();

nombresIdioma.set(IdiomaEnum.ESPANOL, "es");
nombresIdioma.set(IdiomaEnum.PORTUGUES, "pt");
nombresIdioma.set(IdiomaEnum.INGLES, "en");
nombresIdioma.set(IdiomaEnum.FRANCES, "fr");

export const obtenerNombreIdioma: (idioma: IdiomaEnum) => string = idioma => nombresIdioma.get(idioma) ?? "";
